module.exports = __webpack_public_path__ + "media/images/compare-6a7b7974.svg";